import dotenv from 'dotenv';
dotenv.config();

// Create React App always builds with NODE_ENV=production. Deploy targets must
// therefore use an explicit build-time API override instead of relying on a
// separate NODE_ENV such as "staging".
const deployedApiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const isStagingBuild = process.env.REACT_APP_FIREBASE_ENV === 'staging';
const productionApiBaseUrl = 'https://rails-be-gym.fly.dev';
const stagingApiBaseUrl = 'https://rails-be-gym-staging.fly.dev';
const deployedBaseApiUrl = isStagingBuild
  ? stagingApiBaseUrl
  : deployedApiBaseUrl || productionApiBaseUrl;

const appConfig = {
  default: {
    baseApiUrl: deployedBaseApiUrl,
  },
  development: {
    baseApiUrl: 'http://localhost:3000',
  },
  staging: {
    baseApiUrl: stagingApiBaseUrl,
  },
  production: {
    baseApiUrl: deployedBaseApiUrl,
  },
};

export default appConfig[process.env.NODE_ENV] || appConfig.default;
